<template>
   <div>
      <vx-card>
        <vs-row vs-w="12" vs-type="flex" vs-justify="left">
          <vs-button size="medium" color="warning" icon="edit" class="ml-3" @click="$router.go(-1)">Kembali</vs-button>
          <vs-button size="medium" color="primary" icon="print" class="ml-3" @click="cetak()">Cetak</vs-button>
        </vs-row>
        <div class="pdf-content">
          <div class="report-info">
            <h4 class="title">HASIL PEMERIKSAAN LABORATORIUM</h4>
            <div class="patient-info">
              <table>
                <tr>
                  <td class="txt">&nbsp;</td>
                  <td colspan="3" style="text-align: right">
                    <label><b>Dokter Penanggung Jawab : {{kaLab}}</b></label>
                  </td>
                </tr>
                <tr>
                  <td class="txt">Nama</td>
                  <td class="val">: {{dataPatient.patient?dataPatient.patient.name:''}}</td>
                  <td class="txt">No. Laboratorium</td>
                  <td class="val">: {{dataPatient?dataPatient.visitNumber:''}}</td>
                </tr>
                <tr>
                  <td class="txt">No. RM/NIK</td>
                  <td class="val">: {{dataPatient.patient?dataPatient.patient.patientNumber:''}}</td>
                  <td class="txt">Dokter Pengirim</td>
                  <td class="val">: {{dataPatient.physician?dataPatient.physician.name:''}}</td>
                </tr>
                <tr>
                  <td class="txt">Tanggal Lahir/Umur</td>
                  <td class="val">: {{dataPatient.patient.dob | formatDate}} / {{dataPatient.patient.dob | calcAge}} TH</td>
                  <td class="txt">Tipe Kunjungan</td>
                  <td class="val">: {{dataPatient.patientType?dataPatient.patientType.name:''}}</td>
                </tr>
                <tr>
                  <td class="txt">Jenis Kelamin</td>
                  <td class="val">: {{dataPatient.patient.gender?dataPatient.patient.gender.name:''}}</td>
                  <td class="txt">Ruangan</td>
                  <td class="val">: {{dataPatient.ward?dataPatient.ward.name:''}}</td>
                </tr>
                <tr>
                  <td class="txt">Alamat</td>
                  <td class="val">: {{dataPatient.patient?dataPatient.patient.address:''}}</td>
                  <td class="txt">No. Telp</td>
                  <td class="val">: {{dataPatient.patient?dataPatient.patient.phoneNumber:''}}</td>
                </tr>
              </table>
            </div>

            <hr style="margin-top: 20px;"/>
            <div>
              <label style="margin-left:100px"><b>JENIS PEMERIKSAAN</b></label>
              <label style="margin-left:200px"><b>HASIL</b></label>
              <label style="margin-left:60px"><b>UNIT</b></label>
              <label style="margin-left:50px"><b>NILAI RUJUKAN</b></label>
            </div>
            <hr/>

            <div class="test-result">
              <table style="width: 100%">
                  <tbody :key="indextr" v-for="(tr, indextr) in listTest">
                      <vs-tr :data="tr">
                          <vs-td>&nbsp;</vs-td>
                          <vs-td class="val1">{{tr.name}}</vs-td>
                          <vs-td class="val2">&nbsp;</vs-td>
                          <vs-td class="val3">&nbsp;</vs-td>
                          <vs-td class="val2">&nbsp;</vs-td>
                      </vs-tr>
                      <vs-tr :key="indextr1" v-for="(tr1, indextr1) in tr.test" :style="(tr1.outNormal?'color: red;':'')">
                          <vs-td><vs-checkbox v-model="tr1.checked"></vs-checkbox></vs-td>
                          <vs-td class="val4">o {{tr1.name}}</vs-td>
                          <vs-td class="val2">{{tr1.result}}</vs-td>
                          <vs-td class="val3">{{tr1.unit}}</vs-td>
                          <vs-td class="val2">{{tr1.measureRanges}}</vs-td>
                      </vs-tr>
                      <vs-tr :key="'a_'+indextr2" v-for="(tr2, indextr2) in tr.chidlGroup">
                          <vs-td>&nbsp;</vs-td>
                          <vs-td class="val4">o {{tr2.name}}</vs-td>
                          <vs-td class="val2">&nbsp;</vs-td>
                          <vs-td class="val3">&nbsp;</vs-td>
                          <vs-td class="val2">&nbsp;</vs-td>
                      </vs-tr>
                      <vs-tr :key="'b_'+indextr3" v-for="(tr3, indextr3) in (tr.chidlGroup!==null?tr.chidlGroup[0].test:[])" :style="(tr3.outNormal?'color: red;':'')">
                          <vs-td><vs-checkbox v-model="tr3.checked"></vs-checkbox></vs-td>
                          <vs-td class="val5">- {{tr3.name}}</vs-td>
                          <vs-td class="val2">{{tr3.result}}</vs-td>
                          <vs-td class="val3">{{tr3.unit}}</vs-td>
                          <vs-td class="val2">{{tr3.measureRanges}}</vs-td>
                      </vs-tr>
                  </tbody>
              </table>
            </div>
            <div class="footer">
              <div style="margin-top: 10px">
                <label>Keterangan :</label>
                <label style="margin-left: 10px; color: red">* </label>
                <label style="margin-left: 5px;">Abnormal</label>
                <label style="margin-left: 10px; color: red">*** </label>
                <label style="margin-left: 5px;">Nilai Kritis</label>
              </div>
              <table style="width: 800px; margin-top: 20px">
                <tr>
                  <td class="txt">Tgl Pengambilan Sampel</td>
                  <td class="val">: {{dataPatient.createdAt | formatDate}}</td>
                  <td class="txt1">Diperiksa oleh</td>
                  <td class="val">: {{dataPatient.testedBy?dataPatient.testedBy.name:''}}</td>
                </tr>
                <tr>
                  <td class="txt">Waktu Pemeriksaan</td>
                  <td class="val">: {{dataPatient.timeStarted | formatDateTime}}</td>
                  <td class="txt1">Diverifikasi oleh</td>
                  <td class="val">: {{dataPatient.verifiedBy?dataPatient.verifiedBy.name:''}}</td>
                </tr>
                <tr>
                  <td class="txt">Waktu Selesai</td>
                  <td class="val">: {{dataPatient.timeVerified2 | formatDateTime}}</td>
                  <td class="txt1">Divalidasi Teknis oleh</td>
                  <td class="val">: {{dataPatient.verified2By?dataPatient.verified2By.name:''}}</td>
                </tr>
              </table>
              <div style="display: flex">
                <table style="width: 400px; margin-top: 20px">
                  <tr>
                    <td class="txt">Catatan :</td>
                  </tr>
                  <tr>
                    <td class="txt">{{(dataPatient.visitNote.length>0 && dataPatient.visitNote[0].noteType==='VALIDATE')?dataPatient.visitNote[0].note:''}}</td>
                  </tr>
                </table>
                <div style="width: 400px; display: inline-grid">
                  <label style="margin-top: 50px">Penanggung Jawab Laboratorium</label>
                  <label style="margin-left: 10px; margin-top: 50px">{{kaLab}}</label>
                  <label style="margin-left: 5px;">{{nip}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
   </div>
</template>

<script>
import initialConfig from '@/../initialConfig.js';

export default {
    data() {
      return {
        dataPatient: {},
        kaLab: (initialConfig?initialConfig.kaLab:''),
        nip: (initialConfig?initialConfig.nip:''),
        listTest: []
      };
    },
    methods: {
      async cetak() {
        this.$router.push({name: 'clinic-pdf-print', params: { dataPatient : this.dataPatient, listTest : this.listTest }});
      },
    },
    mounted() {
    },
    created() {
      this.dataPatient = this.$route.params;

      if (Object.keys(this.dataPatient).length === 0 && this.dataPatient.constructor === Object) {
        this.$vs.notify({
          title:'Error',
          time:3000,
          text:'Data Pasien tidak ditemukan, silahkan coba lagi dari daftar worklist.',
          color:'danger',
          position:'top-right'
        });

        this.$router.push({name: 'worklist-klinik'});
      } else {
        for (var i=0; i<this.dataPatient.groupTest.length; i++) {
          let dp = this.dataPatient.groupTest[i];
          for (var j=0; j<dp.test.length;j++) {
            dp.test[j].checked=true;
          }

          // child group
          if (dp.chidlGroup!=null) {
            for (var k=0; k<dp.chidlGroup.length;k++) {
              for (var l=0; l<dp.chidlGroup[k].test.length;l++) {
                dp.chidlGroup[k].test[l].checked=true;
              }
            }
          }
          dp.checked = true;
          this.listTest.push(dp);
        }
      }
    }
}
</script>

<style lang="scss" scoped>
  .pdf-content {
    width: 800px;
    padding-top: 76px;
    background-image: url("../assets/images/pages/background_report_rsdcwa.png") ;

    /* Full height */
    height: 100%;

    /* Center and scale the image nicely */
    background-repeat: no-repeat;
    background-size: cover;
    .title {
      text-align: center;
      margin-top: 10px;
    }
    .title1 {
      text-align: right;
      margin-top: 10px;
      font-weight: bold;
    }
    label {
      font-size: 11px;
    }
    .report-info {
      padding:70px 50px 0px 50px;
      .patient-info {
        margin-top: 20px;
        font-size: 11px;
      }
      .patient-info td {
          padding: 5px 10px 0 10px;
      }
      .patient-info td.txt {
          width: 150px;
      }
      .patient-info td.val {
          width: 220px;
      }
      .test-result td {
        padding: 7px 7px 7px 7px;
        text-align: center;
        border-bottom: 1px dashed black;
        font-size: 11px !important;
      }
      .test-result td.val1 {
        width: 50%;
        font-weight: bold;
        text-align: left !important;
        padding-left: 25px !important;
      }
      .test-result td.val2 {
        width: 15%;
      }
      .test-result td.val3 {
        width: 10%;
      }
      .test-result td.val4 {
        width: 50%;
        text-align: left !important;
        padding-left: 35px !important;
      }
      .test-result td.val5 {
        text-align: left !important;
        padding-left: 50px !important;
      }
      .test-result td.val6 {
        width: 50%;
        text-align: left !important;
        padding-left: 70px !important;
      }
      .footer {
          font-size: 11px;
      }
      .footer td.txt {
          width: 170px;
      }
      .footer td.txt1 {
          width: 120px;
      }
      .footer td.val {
          width: 250px;
      }
      .user-details {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        .user-name {
          margin-bottom: 10px;
          margin-top: 30px;
          flex-shrink: 0;
        }
        .detail-container {
          font-size: 13px;
          flex-shrink: 0;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .detail-label {
            font-weight: 600;
            margin-right: 5px;
            font-size: 13px;
          }
        }
      }
      .request-details {
        display: flex;
        flex-direction: column;
        flex-shrink: 0;
        .user-name {
          margin-bottom: 10px;
          flex-shrink: 0;
        }
        .detail-container {
          font-size: 13px;
          flex-shrink: 0;
          &:not(:last-child) {
            margin-bottom: 10px;
          }
          .detail-label {
            font-weight: 600;
            margin-right: 5px;
            font-size: 13px;
          }
        }
      }
    }
  }
</style>
